import React from 'react';
import { Link } from 'react-router-dom';

const links = [
  { to: '/pricing', label: 'Pricing' },
  { to: '/self-managed-strata-software', label: 'Self-Managed Strata Software' },
  { to: '/duplex-strata-management', label: 'Duplex Strata Management' },
  { to: '/strata-management-cost-comparison', label: 'Strata Cost Comparison' },
  { to: '/stratapro-vs-traditional-strata-manager', label: 'StrataPro vs Traditional Manager' },
  { to: '/stratapro-vs-spreadsheets-self-managed', label: 'StrataPro vs Spreadsheets' },
  { to: '/benchmark-report-small-strata-operations', label: 'Benchmark Report' },
  { to: '/compliance/nsw-strata', label: 'NSW Compliance Hub' },
  { to: '/compliance/vic-strata', label: 'VIC Compliance Hub' },
  { to: '/compliance/qld-strata', label: 'QLD Compliance Hub' },
  { to: '/resources/pr-hub', label: 'PR & Resources Hub' },
  { to: '/editorial-standards', label: 'Editorial Standards' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
  { to: '/privacy', label: 'Privacy' }
];

export function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-200">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <nav className="grid md:grid-cols-3 gap-2" aria-label="Footer">
          {links.map((item) => (
            <Link key={item.to} to={item.to} className="text-sm hover:text-white">
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="mt-8 text-sm text-slate-300">
          <p>Contact: hello@stratapro.com.au</p>
          <p className="mt-2">StrataPro provides software tools for strata workflows and record management.</p>
        </div>
        <p className="mt-6 text-xs text-slate-400">© {new Date().getFullYear()} StrataPro. All rights reserved.</p>
      </div>
    </footer>
  );
}
